// styles
import styled from 'styled-components';
import LiteralCurrency from 'components/LiteralCurrency';
import { GirdedInfoIcon } from 'refactored/ui/icons';
import { useTranslation } from 'react-i18next';

const SoFormCandidateBlockDetailsPriceBreakdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 32px;
  background: var(--white);
  border-radius: 0px 0px 4px 4px;
  width: 100%;
`;

const SoFormCandidateBlockDetailsPriceBreakdownContainerItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 30px;
  width: 100%;
`;

const SoFormCandidateBlockDetailsPriceBreakdownItem = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 100%;
  /* border: 3px solid black; */
`;

const SoFormCandidateBlockDetailsPriceBreakdownItemTotalPrice = styled.div`
  width: 100%;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 32px;
  /* grey / 800 */
  color: #3b4f63;
`;

const TotalPriceContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  /* border: 3px solid red; */
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  /* border: 3px solid green; */
`;

const HeaderText = styled.div`
  width: 100%;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  /* grey / 800 */
  color: #3b4f63;
`;

const AccentText = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 16px;
  /* accent / 700 */
  color: var(--accent700);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  text-align: right;
  justify-content: end;
  padding: 8px;
  svg {
    path {
      fill: var(--accent700);
    }
  }
  background: var(--accent300);
`;

const SoFormPriceRange = ({ quote, className }) => {
  const { t } = useTranslation('Catalog');

  const total = quote.net_full_price;

  const ESTIMATION_PRICE_PERCENTAGE = 50;
  const rangeFrom = parseFloat(total);
  const rangeTo =
    parseFloat(total) + (ESTIMATION_PRICE_PERCENTAGE * parseFloat(total)) / 100;
  return (
    <div className={className}>
      <SoFormCandidateBlockDetailsPriceBreakdownContainer>
        <SoFormCandidateBlockDetailsPriceBreakdownContainerItems>
          <HeaderContainer>
            <HeaderText>{t('confirmation.order_price')}</HeaderText>
            <AccentText>
              {t('confirmation.estimate')} <GirdedInfoIcon />
            </AccentText>
          </HeaderContainer>
          <SoFormCandidateBlockDetailsPriceBreakdownItem>
            <TotalPriceContainer>
              <SoFormCandidateBlockDetailsPriceBreakdownItemTotalPrice>
                <LiteralCurrency value={rangeFrom} />
                <span> - </span>
                <LiteralCurrency value={rangeTo} />
              </SoFormCandidateBlockDetailsPriceBreakdownItemTotalPrice>
            </TotalPriceContainer>
          </SoFormCandidateBlockDetailsPriceBreakdownItem>
        </SoFormCandidateBlockDetailsPriceBreakdownContainerItems>
      </SoFormCandidateBlockDetailsPriceBreakdownContainer>
    </div>
  );
};

export default styled(SoFormPriceRange)`
  /* border: 1px solid black; */
  width: 100%;
`;
